import { useMemo } from "react";

interface PrismWordmarkProps {
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

export default function PrismWordmark({ height = 48, style, className }: PrismWordmarkProps) {
  const id = "prism-wm-" + Math.random().toString(36).slice(2, 6);

  const accent = useMemo(
    () => getComputedStyle(document.documentElement).getPropertyValue("--color-accent").trim() || "#00e5ff",
    // Re-evaluate when dev-mode class is toggled
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [document.documentElement.classList.contains("dev-mode")],
  );

  return (
    <svg
      viewBox="-8 6 218 42"
      fill="none"
      height={height}
      className={className}
      style={{ display: "block", ...style }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id={`${id}-grad`} x1="0" y1="0" x2="200" y2="0" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor={accent} stopOpacity="0.8" />
          <stop offset="50%" stopColor={accent} stopOpacity="0.4" />
          <stop offset="100%" stopColor={accent} stopOpacity="0.05" />
        </linearGradient>
      </defs>

      {/* Black backing — fill only, contained within letterforms, no stroke */}
      <text
        x="100"
        y="44"
        textAnchor="middle"
        fontFamily="'Arial Black', 'Impact', 'Inter', sans-serif"
        fontSize="48"
        fontWeight="900"
        letterSpacing="-3"
        fill="black"
        transform="skewX(-15)"
      >
        PRISM
      </text>
      {/* Cyan gradient fill on top */}
      <text
        x="100"
        y="44"
        textAnchor="middle"
        fontFamily="'Arial Black', 'Impact', 'Inter', sans-serif"
        fontSize="48"
        fontWeight="900"
        letterSpacing="-3"
        fill={`url(#${id}-grad)`}
        stroke={accent}
        strokeWidth="1"
        strokeLinejoin="round"
        strokeLinecap="round"
        transform="skewX(-15)"
      >
        PRISM
      </text>
    </svg>
  );
}
